export const pagesFinance: Record<string, string> = {
  OrderFinance: '@finance',
  HomeFinance: '@finance',
  Calculate: '@finance',
};
